import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {WithChildren} from '../../../../template/_metronic/helpers'

interface Props {
  title?: string
  variant: 'danger' | 'primary'
  size: 'lg' | 'md' | 'sm'
  handleClose?: () => void
  handleConfirm?: () => void
  textCancel?: string
  textConfirm?: string
  closeButton?: boolean
  backdrop?: 'static' | undefined
  disableButtons?: boolean
  isLoading?: boolean
}

const ModalComponent: React.FC<Props & WithChildren> = ({
  title,
  variant,
  size,
  handleClose,
  handleConfirm,
  textCancel,
  textConfirm,
  closeButton = true,
  backdrop,
  disableButtons = false,
  isLoading = false,
  children,
}) => {
  return (
    <Modal
      show={true}
      onHide={handleClose}
      className={`modal-${size}`}
      backdrop={backdrop}
      centered
    >
      <Modal.Header className={'border-0'} closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='py-0'>{children}</Modal.Body>
      <Modal.Footer
        className={`border-0 justify-content-center ${size === 'lg' ? 'py-19' : 'py-11'}`}
      >
        {handleClose && (
          <Button
            variant='light-primary-dark'
            onClick={handleClose}
            className={'fs-2 btn-oval me-lg-12'}
          >
            {textCancel ? textCancel : 'Cancelar'}
          </Button>
        )}

        {handleConfirm && (
          <Button
            variant={variant}
            onClick={handleConfirm}
            className={'fs-2 btn-oval'}
            disabled={disableButtons || isLoading}
          >
            {isLoading ? (
              <span className='spinner-border  align-middle text-White' />
            ) : (
              <>{variant === 'danger' ? textConfirm || 'Eliminar' : textConfirm || 'Confirmar'}</>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ModalComponent
